var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[(_vm.isProjectPath)?_c('ProjectLayout'):_vm._e(),(!_vm.isLoginPath && !_vm.isLoginPathPreRegist && !_vm.isNoticePath && !_vm.isProjectPath && !_vm.isFieldPath && !_vm.isDataDictionaryPath && !_vm.isLogPath && !_vm.isSettingPath)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }